export interface TokenConfig {
  symbol: string;
  name: string;
  address: string | "native";
  decimals: number;
  isStablecoin: boolean;
  logoUrl?: string;
}

export interface ChainTokens {
  [tokenSymbol: string]: TokenConfig;
}

// Token configurations - Polygon mainnet only for now
export const TOKENS: Record<number, ChainTokens> = {
  // Polygon (137) - Settlement Chain
  137: {
    USDT: {
      symbol: "USDT",
      name: "Tether USD",
      address: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
      decimals: 6,
      isStablecoin: true,
    },
    USDC: {
      symbol: "USDC",
      name: "USD Coin",
      address: "0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359",
      decimals: 6,
      isStablecoin: true,
    },
    POL: {
      symbol: "POL",
      name: "Polygon",
      address: "native",
      decimals: 18,
      isStablecoin: false,
    },
    LINK: {
      symbol: "LINK",
      name: "Chainlink",
      address: "0x53E0bca35eC356BD5ddDFebbD1Fc0fD03FaBad39",
      decimals: 18,
      isStablecoin: false,
    },
    UNI: {
      symbol: "UNI",
      name: "Uniswap",
      address: "0xb33EaAd8d922B1083446DC23f610c2567fB5180f",
      decimals: 18,
      isStablecoin: false,
    },
    AAVE: {
      symbol: "AAVE",
      name: "Aave",
      address: "0xD6DF932A45C0f255f85145f286eA0b292B21C90B",
      decimals: 18,
      isStablecoin: false,
    },
    ATOM: {
      symbol: "ATOM",
      name: "Cosmos",
      address: "0xac51C4c48Dc3116487eD4BC16542e27B5694Da1b",
      decimals: 6,
      isStablecoin: false,
    },
    RENDER: {
      symbol: "RENDER",
      name: "Render",
      address: "0x61299774020dA444Af134c82fa83E3810b309991",
      decimals: 18,
      isStablecoin: false,
    },
    BONK: {
      symbol: "BONK",
      name: "Bonk",
      address: "0xe5B49820e5A1063F6F4DdF851327b5E8B2301048",
      decimals: 5,
      isStablecoin: false,
    },
    NEXO: {
      symbol: "NEXO",
      name: "Nexo",
      address: "0x41b3966B4FF7b427969ddf5da3627d6AEAE9a48E",
      decimals: 18,
      isStablecoin: false,
    },
    CRV: {
      symbol: "CRV",
      name: "Curve",
      address: "0x172370d5Cd63279eFa6d502DAB29171933a610AF",
      decimals: 18,
      isStablecoin: false,
    },
    GRT: {
      symbol: "GRT",
      name: "The Graph",
      address: "0x5fe2B58c013d7601147DcdD68C143A77499f5531",
      decimals: 18,
      isStablecoin: false,
    },
  },
};

// Settlement token (USDT) - no fees for this token
export const SETTLEMENT_TOKEN = {
  symbol: "USDT",
  decimals: 6,
};

export const getTokensForChain = (chainId: number): ChainTokens => {
  return TOKENS[chainId] || {};
};

export const getToken = (chainId: number, symbol: string): TokenConfig | undefined => {
  return TOKENS[chainId]?.[symbol];
};

export const getSettlementToken = (chainId: number): TokenConfig | undefined => {
  return TOKENS[chainId]?.USDT;
};

export const getNativeToken = (chainId: number): TokenConfig | undefined => {
  const tokens = TOKENS[chainId];
  if (!tokens) return undefined;
  return Object.values(tokens).find((t) => t.address === "native");
};

// Check if token is the settlement token (USDT) - no fees for USDT
export const isSettlementToken = (symbol: string): boolean => {
  return symbol === "USDT";
};

export default TOKENS;
